import { cn, Flex, Icon } from '@bridebook/aura';
import { TriangleWarning } from '@bridebook/aura/src/icons';

/**
 * Shown on any editor surface whose stylesheet could not be fetched. The theme owns the whole layout, so
 * there is no partial render to fall back on: fill the box the preview would have taken and mark it.
 */
export const MotifCssUnavailable = ({ className }: { className?: string }) => (
  <Flex className={cn('items-center justify-center', className)}>
    <Icon icon={TriangleWarning} size={64} className="text-space-40" />
  </Flex>
);
